import { MergeSectionTemplate } from "components/MainSectionTemplate/MergeSectionTemplate";
import { ContactSidePanel } from "components/SidePanel/contact/ContactSidePanel";
import { contactToFormState, getInstruction, ContactFormState } from "shared/utils/fieldsHelper/contactFields";
import React, { useState } from "react";
import { useLoaderData, useSearchParams } from "react-router";
import { routes } from "utilities/routing/generatedRoutes";
import { mainSection } from "./mainSection";
import { socialSection } from "./socialSection";
import { otherDetailSection } from "./otherDetailSection";
import { passportSection } from "./passportSection";
import { homeAddressSeciton } from "./homeAddressSection";

const ContactMergeApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ContactMergeFrontModel>();

  const [searchParams, _] = useSearchParams();
  const fromWebformId = Number.parseInt(searchParams.get("fromWebformId"));
  const redirectUrl = fromWebformId ?
    routes.show_FromWebform(fromWebformId).absolute :
    routes.contact_Detail(viewModel.targetContact.contactId).absolute;

  const existingContact = contactToFormState(viewModel.targetContact, serverReference);
  const existingTags = viewModel.targetContact.tags;

  const sourceContact = contactToFormState(viewModel.sourceContact, serverReference);
  const sourceTags = viewModel.sourceContact.tags;

  const [currentContact, setCurrentContact] = useState<ContactFormState>(existingContact);
  const [currentTags, setCurrentTags] = useState<server.dto.TagSmall[]>(existingTags);

  return <MergeSectionTemplate
    redirectUrl={redirectUrl}
    sourceHeader={<div>
      <ContactSidePanel contactId={viewModel.sourceContact.contactId} trigger={<a>{RESX.GeneralLabels.Source}</a>} />
      <br />
      {RESX.GeneralLabels.ThisRecordWillBeMergedWithTheExistingRecord}
    </div>}
    existingHeader={<div>
      <ContactSidePanel contactId={viewModel.targetContact.contactId} trigger={<a>{RESX.GeneralLabels.ExistingRecord}</a>} />
      <br />
      {RESX.GeneralLabels.ThisRecordWillBeSavedInTheDatabase}
    </div>}
    submit={() => window.CoreApi.Contact.Merge({
      sourceContactId: viewModel.sourceContact.contactId,
      targetContact: getInstruction(currentContact, {}),
    })}
    sections={[
      mainSection(
        existingContact, sourceContact, currentContact, setCurrentContact,
        existingTags, sourceTags, currentTags, setCurrentTags),
      homeAddressSeciton(existingContact, sourceContact, currentContact, setCurrentContact),
      socialSection(existingContact, sourceContact, currentContact, setCurrentContact),
      otherDetailSection(existingContact, sourceContact, currentContact, setCurrentContact),
      passportSection(existingContact, sourceContact, currentContact, setCurrentContact),
    ]}
  />
}

export default ContactMergeApp;